import { render, staticRenderFns } from "./AddEdit.vue?vue&type=template&id=5aca648c&scoped=true&"
import script from "./AddEdit.vue?vue&type=script&lang=js&"
export * from "./AddEdit.vue?vue&type=script&lang=js&"
import style0 from "./AddEdit.vue?vue&type=style&index=0&id=5aca648c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aca648c",
  null
  
)

export default component.exports